import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    MdAccessibilityNew,
    MdOutlineBarChart,
    MdOutlineTimer
} from 'react-icons/md';
import Button from 'components/Button';
import './index.css';

type DigitalInstructionProps = {
    testName: string;
    beginTest: () => void;
};

function DigitalSATInstruction({ testName, beginTest }: DigitalInstructionProps) {
    const navigate = useNavigate();

    return (
        <div className='digitalInstruction'>
            <h1 className='digitalInstruction__heading'>
                {testName}
            </h1>
            <div className='digitalInstruction__items'>
                <h2 className='digitalInstruction__itemTitle'>
                    <MdOutlineTimer className='digitalInstruction__itemIcon' />
                    Timing
                </h2>
                <p className='digitalInstruction__itemContent'>
                    This full-length practice test is timed like the real SAT, but you can pause any time. If you continue on a different device, you'll need to start over.
                </p>
                <h2 className='digitalInstruction__itemTitle'>
                    <MdOutlineBarChart className='digitalInstruction__itemIcon' />
                    Scores
                </h2>
                <p className='digitalInstruction__itemContent'>
                    When you finish the practice test, you will be given your scores as well as the answer keys along with your answers so you can see which questions you got right or wrong.
                </p>
                <h2 className='digitalInstruction__itemTitle'>
                    <MdAccessibilityNew className='digitalInstruction__itemIcon' />
                    Assistive Technology
                </h2>
                <p className='digitalInstruction__itemContent'>
                    We currently do not offer assistive technology. If you are taking the SAT soon, please use the assistive technology in Bluebook app from the College Board so you know what to expect on test day.
                </p>
            </div>
            <div className='digitalInstruction__buttons'>
                <Button
                    className='digitalInstruction__button'
                    secondary
                    onClick={() => navigate(-1)}
                >
                    EXIT
                </Button>
                <Button
                    className='digitalInstruction__button'
                    onClick={beginTest}
                >
                    NEXT
                </Button>
            </div>
        </div>
    );
}

export default DigitalSATInstruction;